
function currencyFormat(cur) {
    console.log('Currency ' + cur);
}

exports.currency = currencyFormat;